export default __webpack_public_path__ + "static/media/cocina-mobile.e91db73e.jpg";